<script>
    import { onMount } from 'svelte';
    import IntroAnim from './IntroAnim.svelte'

    export let headline = '';
    export let dek = '';



    let showAnim = false;
    onMount(() => {
        // player.pause()
        
       
        //sets up to play animation
        setTimeout(function(){
            showAnim = true;
        }, 1000)

            

    });

    
  

</script>
   
   
             
		<div class="foreground">
            <div class='container'>
                <div class='row'>

                

                <section class='scroll-point full trigger'>
                    
                        <div class="scroll-text">
                            <div class='intro-anim start'>
                                {#if showAnim}
                                    <IntroAnim></IntroAnim>
                                {/if}
                            </div>
                            <h1 class='intro-hed'><span class='highlight'>{headline}</span></h1>
                            <p class='intro-lines'><span class='highlight'>{dek}</span></p>
                        </div>
                    
                    </section>
                  
                   
            
                </div>
            </div>
		</div>





<style>

	


    section {
        width: 100%;
    }
    
    section.scroll-point {
        /* height: 100vh; */
    }

    section.scroll-point.half {
        height: 15vh;

       
    }
     @media only screen and (min-width: 480px) {
         section.scroll-point.half {
            height: 30vh;
         }
    }



    .scroll-text {
        max-width: 480px;
        font-family: Knowledge, "Source Sans Pro", Arial, sans-serif;
        font-weight: 400;
        margin: 0 20px;
    }

    .video-overlay {
        position: absolute;
        top: 0; left: 0; bottom: 0; right: 0;
        background-color: rgba(0,0,0,.45);
        transition: background-color 0.5s ease;
    }
    .video-overlay.hide-overlay {
        background-color: rgba(0,0,0,0);
    }

    .intro-anim {
        height: 100px;
    }
    .foreground {
        /* position: absolute;
        top: 20vh;
        left: 0;
        right: 0; */
        position: absolute;
    
        bottom: 100px;
        left: 0;
         right: 0;
        padding-top: 20vh;
       
    }
     @media only screen and (min-width: 1060px) {
         .foreground {
            padding-top: 40vh;
         }
    }

</style>